var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1436 1.69519L10.1436 1.6952L10.145 1.69377C10.3324 1.50068 10.3274 1.19304 10.1335 1.00741C9.94557 0.825492 9.64689 0.825603 9.45906 1.00774L9.45905 1.00773L9.45759 1.00919L5.5774 4.88938L1.69519 1.00919C1.50534 0.819337 1.19771 0.818192 1.00883 1.00954C0.819361 1.1994 0.818315 1.50671 1.00948 1.69548C1.00962 1.69562 1.00976 1.69576 1.0099 1.6959L5.23339 5.91939C5.42325 6.10925 5.73089 6.11039 5.91977 5.91902C5.91988 5.91891 5.91999 5.9188 5.9201 5.91868L10.1436 1.69519Z",
    fill: "#00C6C9",
    stroke: "#00BEC1",
    strokeWidth: 0.267171
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.079bfafd.svg";
export { ForwardRef as ReactComponent };